/* eslint-disable react/jsx-no-duplicate-props */
import * as React from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Modal from '@mui/material/Modal';
import {
  Checkbox,
  Radio,
  Fab,
  InputAdornment,
  MenuItem,
  Switch,
  TextField,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
} from '@mui/material';
import toast from 'react-hot-toast';
import CloseIcon from '@mui/icons-material/Close';
import { useSelector } from 'react-redux';
import Swal from 'sweetalert2';
import _ from 'lodash';
import QRCode from 'qrcode-svg';
import * as Yup from 'yup';

import { updateSafalEventCheckIn } from '../../../services/Service';
import DateField from '../../../components/UI/DateField';
import FileImageView from '../../../components/UI/FileImageView';
import CustomSimpleSelect from '../../../components/UI/CustomSimpleSelect';
import { transformYupErrorsIntoArray } from '../../../utils/fn';
import CustomSearch from '../../../components/UI/CustomSearch';
import useDebounce from '../../../hooks/useDebounce';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 700,
  bgcolor: 'background.paper',
  border: '1px solid #000',
  borderRadius: '8px',
  boxShadow: 24,
  displey: 'flex',
  maxHeight: '95vh',
  overflow: 'auto',
  flexDirection: 'column',
  gap: '12px',
  p: 4,
  '@media (max-width: 640px)': {
    width: '95vw',
    height: '95vh',
    overflow: 'auto',
  },
};

export default function EventCheckInModal({ data, open, onClose }) {
  const { user } = useSelector((state) => state.login);
  const [isDisableAll, setIsDisableAll] = React.useState(false);
  const [openQR, setOpenQR] = React.useState(false);
  const [allPeople, setAllPeople] = React.useState([]);
  const [people, setPeople] = React.useState([]);
  const [searchValue, setSearchValue] = React.useState('');
  const [updateValue, setUpdateValue] = React.useState([]);

  const onCloseThis = (refetchFlag) => {
    setIsDisableAll(false);
    onClose(refetchFlag);
  };

  const handleClose = async (refetchFlag) => {
    onCloseThis(refetchFlag);
  };

  const onSubmit = async () => {
    if (updateValue.length === 0) {
      handleClose(true);
      return;
    }
    setIsDisableAll(true);
    try {
      await Promise.allSettled(
        updateValue.map(async (up) => {
          await updateSafalEventCheckIn(up);
        })
      );
      toast.success('Checked In Update Successfully');
      handleClose(true);
    } catch (err) {
      toast.error(err?.response?.data?.message || err.message);
    } finally {
      setIsDisableAll(false);
    }
  };

  const onOrOpen = () => {
    setOpenQR(true);
  };
  const onOrClose = () => {
    setOpenQR(false);
  };

  React.useEffect(() => {
    const _allPeople = [];
    data?.invites?.forEach((inv) => {
      const people = inv?.people
        ?.filter((ex) => ex?.status === 'Accepted')
        ?.map((p) => ({
          ...p,
          inviteId: inv?._id,
        }));

      _allPeople.push(...people);
    });
    setAllPeople(_allPeople);
    setPeople(_allPeople);
  }, [data]);

  useDebounce(
    () => {
      if (searchValue.length < 3) {
        setPeople(allPeople);
        return;
      }
      const filtered = allPeople.filter((p) =>
        `${p?.accountData?.firstName} ${p?.accountData?.lastName} ${p?.accountData?.email} ${p?.email}`
          .toLowerCase()
          .includes(searchValue.toLowerCase())
      );
      setPeople(filtered);
    },
    [searchValue],
    1000
  );

  const handleUpdateValue = (po, newStatus) => {
    const newUpData = [...updateValue];
    const findPo = newUpData?.findIndex((up) => up?.email === po?.email);
    if (findPo !== -1) {
      newUpData[findPo].checkIn = newStatus;
    } else {
      newUpData.push({ email: po?.email, checkIn: newStatus, inviteId: po?.inviteId });
    }
    setUpdateValue(newUpData);
  };

  return (
    <>
      <Modal sx={{ zIndex: 345 }} open={open} onClose={handleClose}>
        <Box sx={style}>
          <Fab
            sx={{
              position: 'absolute',
              top: '10px',
              right: '10px',
            }}
            onClick={handleClose}
            size="small"
            color="primary"
            aria-label="add"
          >
            <CloseIcon />
          </Fab>
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
            }}
          >
            <Typography variant="h4" gutterBottom sx={{ fontSize: '24px', fontWeight: 700, color: '#3D71FF' }}>
              Event Check-In
            </Typography>
          </div>
          <div>
            <div style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
              <CustomSearch
                value={searchValue}
                onChange={(e) => setSearchValue(e.target.value)}
                placeholder="Search..."
              />
              <Button
                disabled={isDisableAll}
                onClick={onOrOpen}
                sx={{ backgroundColor: '#3D71FF', borderRadius: '30px', textTransform: 'capitalize' }}
                variant="contained"
              >
                OR Code
              </Button>
            </div>
            <div style={{ marginTop: '16px', display: 'flex', flexDirection: 'column', gap: '8px' }}>
              {people?.map((po, index) => {
                const foundInUpdateList = updateValue?.find((u) => u?.email === po?.email);

                const _checkInStatus = po?.checkIn || 'Pending';
                const checkInStatus = foundInUpdateList ? foundInUpdateList?.checkIn : _checkInStatus;

                return (
                  <div
                    key={index}
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'space-between',
                      padding: '4px 16px',
                      color: checkInStatus === 'Pending' ? 'red' : 'green',
                    }}
                  >
                    {po?.accountData ? (
                      <p>
                        {po?.accountData?.firstName} {po?.accountData?.lastName} ({po?.accountData?.email})
                      </p>
                    ) : (
                      <p>{po?.email}</p>
                    )}
                    <select value={checkInStatus} onChange={(e) => handleUpdateValue(po, e.target.value)}>
                      <option value="Pending">Pending</option>
                      <option value="Done">Done</option>
                    </select>
                  </div>
                );
              })}
            </div>
          </div>
          <div style={{ display: 'flex', gap: '12px', marginTop: '22px', justifyContent: 'end' }}>
            <Button
              disabled={isDisableAll}
              sx={{
                backgroundColor: '#ff4842',
                ':hover': { backgroundColor: '#d40700' },
                color: 'white',
                borderRadius: '30px',
                textTransform: 'capitalize',
              }}
              onClick={handleClose}
              variant="contained"
            >
              Cancel
            </Button>
            <Button
              disabled={isDisableAll}
              onClick={onSubmit}
              sx={{ backgroundColor: '#3D71FF', borderRadius: '30px', textTransform: 'capitalize' }}
              variant="contained"
            >
              Save
            </Button>
          </div>
        </Box>
      </Modal>
      <QRDialog onClose={onOrClose} open={openQR} data={data} />
    </>
  );
}

const QRDialog = ({ onClose, open, data }) => {
  const [qrSVG, setQrSVG] = React.useState('');

  const handleClose = () => {
    onClose?.();
  };

  React.useEffect(() => {
    if (!open) return;
    // const evData = {
    //   eventId: data?._id,
    //   eventCode: data?.code,
    // };
    // const qrData = JSON.stringify(evData);
    const qrData = `https://dev.safalsubscriptions.com/safalevent-invite-check-in/${data?._id}`;
    const qrcode = new QRCode({
      content: qrData,
      container: 'svg-viewbox', // Responsive use
      join: true, // Crisp rendering and 4-5x reduced file size
      width: 400,
      height: 400,
      color: 'black',
      background: 'white',
    });
    const svg = qrcode.svg();
    setQrSVG(svg);
  }, [data, open]);

  return (
    <Dialog open={open} onClose={() => handleClose()}>
      <DialogTitle>Event Check-In QR Code</DialogTitle>
      <DialogContent>
        <div style={{ height: '400px', width: '400px', margin: 'auto' }} dangerouslySetInnerHTML={{ __html: qrSVG }} />
      </DialogContent>
      <DialogActions>
        <Button onClick={() => handleClose()}>Close</Button>
      </DialogActions>
    </Dialog>
  );
};
